module.exports = __webpack_public_path__ + "packs/media/images/box_2-c9fe85b1abd4dd0f58fbc9680fbcdc52.png";